var React = require('react');
var createReactClass = require('create-react-class');
var FuzzyReaction = require('../../bootstrap').FuzzyReaction;
var assign = require('object-assign');
var Table = FuzzyReaction.Components.Visualization.Tables.Table;
var Paginator = FuzzyReaction.Components.Visualization.Pagination.PaginatedButtons;
var PerPageSelector = FuzzyReaction.Components.Visualization.Pagination.PerPageSelector;
var PageSearch = FuzzyReaction.Components.Visualization.PageSearch;
var Modal = FuzzyReaction.Components.Global.Modal;
var Column = FuzzyReaction.Components.PageStructure.Column;
var Row = FuzzyReaction.Components.PageStructure.Row;
var AddAction = FuzzyReaction.Components.ResourceBinding.CreateResourceAction;
var ResourceActions = FuzzyReaction.Actions.ResourceActions;
var Form = FuzzyReaction.Components.ResourceBinding.Form.Form;
var FormStore = FuzzyReaction.Stores.FormStore;
var GenresStore = require('../../stores/GenresStore');

var GenresPage = createReactClass({
    displayName: 'GenresPage',

    getInitialState: function () {
		return {
			currentPageData:     [],
			workingResource:     {},
			openDeactivateModal: false,
			openEditModal:       false
		}
	},

    getOptions: {
		modifiers: {
			other: {
				show_deleted: true
			}
		},
		dataNode:  'data'
	},

    sendOptions: {
		modifiers: {
			other: {
				show_deleted: true
			}
		},
		dataNode: 'data',
		refresh: 'list'
	},

    resourceAction: new ResourceActions('genres'),

    /**
	 * Fire an action to request data from the API
	 */
    requestTableData: function (modifiers) {
		// Merge modifiers with already present ones
		this.getOptions.modifiers = assign(this.getOptions.modifiers, modifiers, {});

		this.resourceAction.listResource(this.getOptions);
	},

    /**
	 * Register event listeners and fire request for data
	 */
    componentDidMount: function () {
		this.requestTableData();

		this.changeListener = this._onChange;
		GenresStore.addChangeListener(this.changeListener);
		FormStore.addChangeListener(this.bindResource);
	},

    /**
	 * Deregister an event listener
	 */
    componentWillUnmount: function () {
		GenresStore.removeChangeListener(this.changeListener);
		FormStore.removeChangeListener(this.bindResource);
	},

    /**
	 * Handle changes in data and request paginated data
	 *
	 * @private
	 */
    _onChange: function () {
		this.setState({
			currentPageData: GenresStore.getResourceListData()
		});
	},

    /**
	 * Update the bound resource on change
	 */
    bindResource: function () {
		this.setState({
			workingResource: FormStore.getResource(this.formKey)
		});
	},

    /**
	 * @todo the modals can be their own components
	 * @param action
	 * @param resource
	 */
    handleAction: function (action, resource) {
		switch (action) {
			case 'deactivate':
				this.setState({
					openDeactivateModal: true,
					workingResource:     resource,
					resourceOperation:   action
				});
				break;
			case 'saveRow':
				this.resourceAction.updateResource(resource, this.sendOptions);
				break;
			case 'cancelEditRow':
				this.requestTableData();
				break;
			case 'create':
				this.setState({
					openEditModal:     true,
					workingResource:   {},
					resourceOperation: action
				});
				break;
		}
	},

    /**
	 * Fire the deactivate genre action
	 */
    deactivateGenre: function () {
		this.resourceAction.deactivateResource(this.state.workingResource, this.sendOptions);
	},

    /**
	 * Fire the create genre action
	 */
    createGenre: function () {
		this.resourceAction.createResource(this.state.workingResource, this.sendOptions);
	},

    /**
	 * Close all modals and reset the working resource
	 */
    closeModal: function () {
		this.setState({
			openEditModal:       false,
			openDeactivateModal: false,
			workingResource:     {}
		});
	},

    tableKeys: {
		"Genre Name": "label"
	},

    render: function () {
		var options = {
			actionableRows:  true,
			actions:         ['deactivate:danger'],
			actionsCallback: this.handleAction,
			editableRows:    true,
			tooltips:        {
				'Genre Name': 'Name of genre'
			}
		};

		return (
			<div id="page-wrapper">
				<div id="page-content">
					<div id="content"></div>
					<Row classes="align-items-center">
						<Column grid="lg" size="8">
							<h1 className="page-header">Genres</h1>
						</Column>

						<Column grid="lg" size="4">
							<div className="page-header">
								<PageSearch actionMethod={this.requestTableData}
									searchable={['label']} />
							</div>
						</Column>
					</Row>

					<Row>
						<Column grid="lg" size="12">
							<Table data={this.state.currentPageData}
								dataKeys={this.tableKeys}
								title={'Genres'} options={options} />

							<Paginator actionMethod={this.requestTableData} />

							<PerPageSelector actionMethod={this.requestTableData} />

						</Column>
					</Row>
				</div>

				<Modal openWhen={this.state.openDeactivateModal}
					title="Deactivate?" closeText="Close"
					saveText="Deactivate" afterClose={this.closeModal}
					beforeSave={this.deactivateGenre}
					afterSave={this.closeModal} >
					<p>You’re about to deactivate a resource.</p>
					<p>Continue with deactivating the resource&#63;</p>
				</Modal>

				<AddAction createResource={this.handleAction}>
					{this.state.openEditModal && (
						<Modal openWhen={this.state.openEditModal} options={{width: '30%'}}
							title="Add Genre"
							closeText="Close" saveText="Save"
							afterClose={this.closeModal}
							beforeSave={this.createGenre}
							afterSave={this.closeModal} >

							<Form key="editSubscription" formKey={this.formKey}
								bindResource={this.state.workingResource} >
								<Row>
									<Column grid="sm" size="12">
										<Form.Input fieldKey="label" type="text" label="Genre Name" placeholder="Enter Name.." limit={120} validations="isLength:4:120" />
									</Column>
								</Row>
							</Form>

						</Modal>
					)}
				</AddAction>
			</div>
		)
	},
});

module.exports = GenresPage;
